import React, { createContext, useContext, useState, useEffect } from "react";
import { doc, onSnapshot } from "firebase/firestore";

import { dbProduction } from "../../backend/firebaseConfig";
import { useUserEmail } from "./UserEmailContext";

const UserPermissionsContext = createContext();

export const UserPermissionsProvider = ({ children }) => {
  const { userEmail } = useUserEmail();

  const [userPermissions, setUserPermissions] = useState(() => {
    try {
      const storedPermissions = localStorage.getItem("userPermissions");
      return storedPermissions ? JSON.parse(storedPermissions) : []; // Ensure it's an array
    } catch (error) {
      // console.error("Error parsing userPermissions from localStorage:", error);
      return []; // Default to empty array if JSON parsing fails
    }
  });

  useEffect(() => {
    try {
      if (Array.isArray(userPermissions)) {
        localStorage.setItem(
          "userPermissions",
          JSON.stringify(userPermissions),
        );
      } else {
        localStorage.removeItem("userPermissions");
      }
    } catch (error) {
      // console.error("Error saving userPermissions to localStorage:", error);
    }
  }, [userPermissions]);

  useEffect(() => {
    const email = String(userEmail || localStorage.getItem("userEmail") || "")
      .toLowerCase()
      .trim();

    if (!email) {
      setUserPermissions([]);
      return undefined;
    }

    const userRef = doc(
      dbProduction,
      "Authorized Members",
      "Staff",
      "Data",
      email,
    );

    return onSnapshot(
      userRef,
      (snapshot) => {
        if (!snapshot.exists()) {
          setUserPermissions([]);
          return;
        }

        const userData = snapshot.data() || {};
        const permissions = Array.isArray(userData.permissions)
          ? userData.permissions
          : [];

        setUserPermissions(permissions);
      },
      () => {
        setUserPermissions([]);
      },
    );
  }, [userEmail]);

  return (
    <UserPermissionsContext.Provider
      value={{ userPermissions, setUserPermissions }}
    >
      {children}
    </UserPermissionsContext.Provider>
  );
};

//  Ensure `useUserPermissions` is used inside a Provider
export const useUserPermissions = () => {
  const context = useContext(UserPermissionsContext);
  if (!context) {
    throw new Error(
      "useUserPermissions must be used within a UserPermissionsProvider"
    );
  }
  return context;
};
